import { render, staticRenderFns } from "./CommunityViewForm.vue?vue&type=template&id=9d99622c&scoped=true&"
import script from "./CommunityViewForm.vue?vue&type=script&lang=js&"
export * from "./CommunityViewForm.vue?vue&type=script&lang=js&"
import style0 from "./CommunityViewForm.vue?vue&type=style&index=0&id=9d99622c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d99622c",
  null
  
)

export default component.exports